import { Component, EventEmitter, HostListener, OnInit, OnDestroy, AfterViewInit, NgZone } from '@angular/core';
import { ViewChild, ViewChildren, QueryList, ElementRef, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MycontentserviceService } from 'src/app/_service/mycontentservice.service';
import { URLS } from 'src/app/constants/URLS';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';
import { environment } from 'src/environments/environment';
import { WhiteLabelService } from 'src/app/_service/white-label.service';
import { DeviceService } from 'src/app/_service/tv-detect.service';
import { IosBridgeService } from 'src/app/_service/ios-bridge.service';
import { TVNavigationService, Region } from 'src/app/_service/tv-navigation.service';
import { ShortsFeedService } from 'src/app/_service/shorts-feed.service';

@Component({
  selector: 'app-movie-thumbnail',
  templateUrl: './movie-thumbnail.component.html',
  styleUrls: ['./movie-thumbnail.component.css'],
})

export class MovieThumbnailComponent implements OnInit, OnDestroy, AfterViewInit {

  isLoading: boolean = false;
  imgLoading: boolean = false;
  imgUrl:string = URLS.imgUrl;
  @ViewChild('owlCarousel', { static: false }) owlCarousel: ElementRef;
  @ViewChild('gridContainer', { static: false }) gridContainer: ElementRef;
  @ViewChild('carouselTrack', { static: false }) carouselTrack: ElementRef;
  @ViewChildren('movieCard') cardRefs!: QueryList<ElementRef>;
  @Input() setToptoZero = false;
  @Input() movies: any[] = [];
  @Input() carouselOptions: any = {};
  @Input() isCarousel: boolean = false;
  @Input() rowId?: string;
  @Input() tvGridColumns: number = 0; // When > 0 on TV, renders as grid with D-pad row navigation
  isCarouselEnabled: boolean = false;
  private gridRowRegionIds: string[] = [];
  @Input() removeFromArrayOnUnwatchlist: boolean = false;
  // Optional section context — set by category-movie / percategory rails so
  // Shorts inside this section open the swipe-feed player. Other consumers
  // (search, watchlist, video-details "more like this") leave it unset →
  // Shorts open in single-short mode.
  @Input() sectionCategoryId: string | null = null;
  // Section template — only `section-shorts-scrollview` is a dedicated
  // shorts rail. Mixed templates that happen to contain a stray short
  // open it in single-short mode (no paging).
  @Input() sectionTemplate: string | null = null;
  @Output() movieRemovedFromWatchlist = new EventEmitter<any>();
  @Output() movieAddedToWatchlist = new EventEmitter<any>();
  @Output() tvFocusedMovie = new EventEmitter<any>();
  currentIndex = 0;
  translateX = 0;
  isAnimating = false;
  itemWidth = 0;
  itemsPerView = 1;
  maxIndex = 0;
  showNavigation = true;
  marginRight = 0;
  containerWidth = 0;
  private isDragging = false;
  private startX = 0;
  private startY = 0;
  private currentX = 0;
  private currentY = 0;
  private lastX = 0;
  private lastY = 0;
  private initialTranslateX = 0;
  private startTime = 0;
  private lastTime = 0;
  private velocityX = 0;
  private velocityY = 0;
  private isHorizontalSwipe = false;
  private isVerticalSwipe = false;
  private swipeDecided = false;
  private touchStarted = false;
  private moved = false;
  private minSwipeDistance = 10;
  private snapThreshold = 0.3;
  private resizeObserver?: ResizeObserver;
  private animationFrameId: number = 0;

  // Bound event handler references (for proper removeEventListener)
  private boundOnTouchStart = this.onTouchStart.bind(this);
  private boundOnTouchMove = this.onTouchMove.bind(this);
  private boundOnTouchEnd = this.onTouchEnd.bind(this);
  private boundOnMouseDown = this.onMouseDown.bind(this);
  private boundOnMouseMove = this.onMouseMove.bind(this);
  private boundOnMouseUp = this.onMouseUp.bind(this);
  private boundNativeNavigateHandler = this.onNativeNavigate.bind(this);

  // TV Navigation state
  private destroy$ = new Subject<void>();
  private generatedRegionId?: string;
  focusedCardIndex = -1;

  constructor(
    private mycontentservice: MycontentserviceService,
    private dialog: MatDialog,
    private router: Router,
    private toastrService: CustomControlsService,
    private ngZone: NgZone,
    private whitelabelService: WhiteLabelService,
    private device: DeviceService,
    private bridgeService: IosBridgeService,
    private tvNav: TVNavigationService,
    private shortsFeed: ShortsFeedService
  ) {
    window.addEventListener('nativeNavigate', this.boundNativeNavigateHandler);
  }

  private onNativeNavigate(event: any): void {
    this.router.navigate([event?.detail?.returnRoute]);
  }

  ngOnInit(): void {
    this.updateCarouselView();
  }

  ngAfterViewInit(): void {
    requestAnimationFrame(() => {
      this.setupCarousel();
    });

    // TV Navigation registration
    if (this.device.isTV()) {
      setTimeout(() => {
        this.registerWithNavigation();
      }, 100);

      this.cardRefs?.changes
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.registerWithNavigation();
        });

      this.tvNav.focus$
        .pipe(takeUntil(this.destroy$))
        .subscribe(focusKey => {
          const regionId = this.rowId || this.generatedRegionId;
          let matched = false;

          // Check grid row regions
          if (focusKey && this.gridRowRegionIds.length > 0) {
            for (let r = 0; r < this.gridRowRegionIds.length; r++) {
              const gridRowId = this.gridRowRegionIds[r];
              if (focusKey.startsWith(`${gridRowId}:`)) {
                const colIndex = parseInt(focusKey.split(':')[1], 10);
                this.focusedCardIndex = r * this.tvGridColumns + colIndex;
                matched = true;
                break;
              }
            }
          }

          // Check single region
          if (!matched && focusKey && regionId && focusKey.startsWith(`${regionId}:`)) {
            this.focusedCardIndex = parseInt(focusKey.split(':')[1], 10);
            matched = true;
          }

          if (matched) {
            this.scrollToFocusedCard(this.focusedCardIndex);
            if (this.focusedCardIndex >= 0 && this.focusedCardIndex < this.movies?.length) {
              this.tvFocusedMovie.emit(this.movies[this.focusedCardIndex]);
            }
          } else {
            this.focusedCardIndex = -1;
          }
        });
    }
  }

  ngOnDestroy(): void {
    // TV Navigation cleanup
    this.destroy$.next();
    this.destroy$.complete();

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
    this.removeEventListeners();
    window.removeEventListener('nativeNavigate', this.boundNativeNavigateHandler);

    if (this.device.isTV()) {
      const regionId = this.rowId || this.generatedRegionId;
      if (regionId) {
        this.tvNav.unregisterRegion(regionId);
      }
      this.gridRowRegionIds.forEach(id => this.tvNav.unregisterRegion(id));
    }
  }

  private setupCarousel(): void {
    if (this.isCarouselEnabled) {
      this.calculateDimensions();
      this.setupResizeObserver();
      this.setupEventListeners();
    }
  }

  private registerWithNavigation(): void {
    if (!this.cardRefs || this.cardRefs.length === 0) return;

    // Generate unique ID if not provided
    if (!this.rowId && !this.generatedRegionId) {
      this.generatedRegionId = `movie-thumbnail-${Date.now()}`;
    }

    const regionId = this.rowId || this.generatedRegionId;
    if (!regionId) return;

    // Grid mode: register each visual row as a separate region for UP/DOWN navigation
    if (this.tvGridColumns > 0 && !this.isCarouselEnabled) {
      // Clean up previous grid row regions
      this.gridRowRegionIds.forEach(id => this.tvNav.unregisterRegion(id));
      this.gridRowRegionIds = [];

      const allCards = this.cardRefs.toArray();
      const cols = this.tvGridColumns;
      const rowCount = Math.ceil(allCards.length / cols);

      for (let r = 0; r < rowCount; r++) {
        const rowCards = allCards.slice(r * cols, (r + 1) * cols);
        const rowRegionId = `${regionId}-grid-row-${r}`;
        this.gridRowRegionIds.push(rowRegionId);
        this.tvNav.registerRegion({
          id: rowRegionId,
          type: 'row',
          elementRef: rowCards[0],
          focusableItems: rowCards
        });
      }
      return;
    }

    // Standard single-row registration (carousel or non-grid)
    const region: Region = {
      id: regionId,
      type: 'row',
      elementRef: this.owlCarousel || this.gridContainer,
      focusableItems: this.cardRefs.toArray()
    };
    this.tvNav.registerRegion(region);
  }
  
  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.updateCarouselView();
    requestAnimationFrame(() => {
      this.calculateDimensions();
    });
  }
  
  updateCarouselView() {
    const screenWidth = window.innerWidth;
    const minItemsForCurrentScreen = this.getMinItemsForScreen(screenWidth);
    // TV grid mode: force grid layout (no carousel)
    // TV carousel mode: enable carousel for D-pad row navigation
    if (this.device.isTV() && this.tvGridColumns > 0) {
      this.isCarouselEnabled = false;
    } else {
      this.isCarouselEnabled = this.device.isTV()
        ? (!!this.isCarousel && (this.movies?.length ?? 0) > 0)
        : (this.movies?.length > minItemsForCurrentScreen && this.isCarousel);
    }
    if (this.isCarouselEnabled) {
      this.updateResponsiveSettings();
      requestAnimationFrame(() => {
        this.calculateDimensions();
      });
    }
  }

  private updateResponsiveSettings() {
    const screenWidth = window.innerWidth;
    const responsiveConfig = this.getResponsiveConfigForScreen(screenWidth);
    this.itemsPerView = responsiveConfig.items;
    this.marginRight = responsiveConfig.margin || 0;
    this.showNavigation = responsiveConfig.nav !== false && this.customOptions.nav !== false;
  }

  private getResponsiveConfigForScreen(screenWidth: number) {
    const breakpoints = Object.keys(this.customOptions.responsive).map(key => parseInt(key)).sort((a, b) => b - a);
    for (const breakpoint of breakpoints) {
      if (screenWidth >= breakpoint) {
        return this.customOptions.responsive[breakpoint];
      }
    }
    const smallestBreakpoint = Math.min(...breakpoints);
    return this.customOptions.responsive[smallestBreakpoint];
  }

  private calculateDimensions() {
    if (!this.owlCarousel || !this.isCarouselEnabled) return;
    this.containerWidth = this.owlCarousel.nativeElement.offsetWidth;
    const totalItems = this.movies.length;
    if (totalItems === 0) return;
    const totalMarginSpace = this.marginRight * (this.itemsPerView - 1);
    const availableSpace = this.containerWidth - totalMarginSpace;
    this.itemWidth = Math.floor(availableSpace / this.itemsPerView);
    if (this.itemWidth < 50) {
      this.itemWidth = Math.floor(this.containerWidth / this.itemsPerView);
    }
    this.maxIndex = Math.max(0, totalItems - this.itemsPerView);
    if (this.currentIndex > this.maxIndex) {
      this.currentIndex = this.maxIndex;
    }
    this.updateTransform();
  }

  private updateTransform() {
    const newTranslateX = -(this.currentIndex * (this.itemWidth + this.marginRight));
    this.translateX = newTranslateX;
  }

  /**
   * TV: Hotstar-style — always keep the focused card as the first visible card.
   * When pressing RIGHT, the carousel slides left so the new card is at position 0.
   */
  private scrollToFocusedCard(cardIndex: number) {
    if (!this.isCarouselEnabled || this.itemWidth === 0) return;

    // Always position the focused card as the first visible (leftmost) card
    this.currentIndex = Math.min(cardIndex, this.maxIndex);
    this.isAnimating = true;

    // For the last few items, add extra scroll so the focused card isn't clipped
    const totalItems = this.movies.length;
    const itemSize = this.itemWidth + this.marginRight;
    if (cardIndex >= totalItems - this.itemsPerView) {
      // Scroll further to ensure last items are fully visible with focus border
      const extraPadding = 40;
      this.translateX = -(this.currentIndex * itemSize) - extraPadding;
    } else {
      this.updateTransform();
    }
    setTimeout(() => this.isAnimating = false, 350);
  }

  private setupResizeObserver() {
    if (typeof ResizeObserver !== 'undefined' && this.owlCarousel) {
      this.resizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(() => {
          if (this.isCarouselEnabled) {
            this.calculateDimensions();
          }
        });
      });
      this.resizeObserver.observe(this.owlCarousel.nativeElement);
    }
  }

  private setupEventListeners() {
    if (this.carouselTrack) {
      const element = this.carouselTrack.nativeElement;
      element.addEventListener('touchstart', this.boundOnTouchStart, { passive: false });
      element.addEventListener('touchmove', this.boundOnTouchMove, { passive: false });
      element.addEventListener('touchend', this.boundOnTouchEnd, { passive: false });
      element.addEventListener('touchcancel', this.boundOnTouchEnd, { passive: false });
      element.addEventListener('mousedown', this.boundOnMouseDown, { passive: false });
      document.addEventListener('mousemove', this.boundOnMouseMove, { passive: false });
      document.addEventListener('mouseup', this.boundOnMouseUp, { passive: false });
    }
  }

  private removeEventListeners() {
    if (this.carouselTrack) {
      const element = this.carouselTrack.nativeElement;
      element.removeEventListener('touchstart', this.boundOnTouchStart);
      element.removeEventListener('touchmove', this.boundOnTouchMove);
      element.removeEventListener('touchend', this.boundOnTouchEnd);
      element.removeEventListener('touchcancel', this.boundOnTouchEnd);
      element.removeEventListener('mousedown', this.boundOnMouseDown);
      document.removeEventListener('mousemove', this.boundOnMouseMove);
      document.removeEventListener('mouseup', this.boundOnMouseUp);
    }
  }

  next() {
    if (this.currentIndex < this.maxIndex && !this.isAnimating) {
      this.currentIndex++;
      this.smoothSlide();
    }
  }

  prev() {
    if (this.currentIndex > 0 && !this.isAnimating) {
      this.currentIndex--;
      this.smoothSlide();
    }
  }

  private smoothSlide() {
    this.isAnimating = true;
    this.updateTransform();
    setTimeout(() => {
      this.isAnimating = false;
    }, 300);
  }

  onTouchStart(event: TouchEvent) {
    if (!this.customOptions.touchDrag || !this.isCarouselEnabled) return;
    if (event.touches.length === 1) {
      const touch = event.touches[0];
      this.touchStarted = true;
      this.moved = false;
      this.swipeDecided = false;
      this.isHorizontalSwipe = false;
      this.isVerticalSwipe = false;
      this.startX = touch.clientX;
      this.startY = touch.clientY;
      this.currentX = touch.clientX;
      this.currentY = touch.clientY;
      this.lastX = touch.clientX;
      this.lastY = touch.clientY;
      this.initialTranslateX = this.translateX;
      this.startTime = Date.now();
      this.lastTime = this.startTime;
      this.velocityX = 0;
      this.velocityY = 0;
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = 0;
      }
    }
  }

  onTouchMove(event: TouchEvent) {
    if (!this.touchStarted || event.touches.length !== 1) return;
    const touch = event.touches[0];
    const now = Date.now();
    this.currentX = touch.clientX;
    this.currentY = touch.clientY;
    const deltaX = this.currentX - this.startX;
    const deltaY = this.currentY - this.startY;
    if (!this.swipeDecided && (Math.abs(deltaX) > this.minSwipeDistance || Math.abs(deltaY) > this.minSwipeDistance)) {
      this.isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY);
      this.isVerticalSwipe = Math.abs(deltaY) > Math.abs(deltaX);
      this.swipeDecided = true;
    }
    if (this.swipeDecided && this.isHorizontalSwipe) {
      this.moved = true;
      this.isDragging = true;
      if (now - this.lastTime > 16) {
        this.velocityX = (this.currentX - this.lastX) / (now - this.lastTime);
        this.lastX = this.currentX;
        this.lastTime = now;
      }
      this.updateCarouselPosition(deltaX);
      event.preventDefault();
      event.stopPropagation();
    }
    else if (this.swipeDecided && this.isVerticalSwipe) {
      return;
    }
  }

  onTouchEnd(event: TouchEvent) {
    if (!this.touchStarted) return;
    this.touchStarted = false;
    if (this.isDragging && this.moved) {
      this.endDrag();
      event.preventDefault();
      event.stopPropagation();
    }
    this.resetDragState();
  }

  onMouseDown(event: MouseEvent) {
    if (!this.customOptions.mouseDrag || !this.isCarouselEnabled) return;
    this.isDragging = true;
    this.startX = event.clientX;
    this.currentX = event.clientX;
    this.lastX = event.clientX;
    this.initialTranslateX = this.translateX;
    this.startTime = Date.now();
    this.lastTime = this.startTime;
    this.velocityX = 0;
    event.preventDefault();
    event.stopPropagation();
  }

  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;
    const now = Date.now();
    this.currentX = event.clientX;
    if (now - this.lastTime > 16) {
      this.velocityX = (this.currentX - this.lastX) / (now - this.lastTime);
      this.lastX = this.currentX;
      this.lastTime = now;
    }
    const deltaX = this.currentX - this.startX;
    this.updateCarouselPosition(deltaX);
    event.preventDefault();
  }

  onMouseUp(event: MouseEvent) {
    if (!this.isDragging) return;
    this.endDrag();
    this.resetDragState();
  }

  private updateCarouselPosition(deltaX: number) {
    let newTranslateX = this.initialTranslateX + deltaX;
    const maxTranslateX = 0;
    const minTranslateX = -((this.itemWidth + this.marginRight) * this.maxIndex);
    if (newTranslateX > maxTranslateX) {
      newTranslateX = maxTranslateX + (newTranslateX - maxTranslateX) * 0.3;
    } else if (newTranslateX < minTranslateX) {
      newTranslateX = minTranslateX + (newTranslateX - minTranslateX) * 0.3;
    }
    this.ngZone.runOutsideAngular(() => {
      this.translateX = newTranslateX;
    });
  }

  private endDrag() {
    this.isDragging = false;
    const deltaX = this.currentX - this.startX;
    const duration = Date.now() - this.startTime;
    const itemSize = this.itemWidth + this.marginRight;
    const currentPosition = -this.translateX / itemSize;
    if (Math.abs(this.velocityX) > 1.0 && duration < 300) {
      const velocityFactor = Math.abs(this.velocityX) * 2;
      const itemsToMove = Math.min(Math.ceil(velocityFactor), 3); 
      if (this.velocityX > 0) {
        this.currentIndex = Math.max(0, Math.floor(currentPosition) - itemsToMove + 1);
      } else {
        this.currentIndex = Math.min(this.maxIndex, Math.floor(currentPosition) + itemsToMove);
      }
    } else {
      this.currentIndex = Math.round(currentPosition);
    }
    this.currentIndex = Math.max(0, Math.min(this.currentIndex, this.maxIndex));
    this.animateToPosition();
  }

  private animateToPosition() {
    const targetX = -(this.currentIndex * (this.itemWidth + this.marginRight));
    this.isAnimating = true;
    this.translateX = targetX;
    setTimeout(() => {
      this.isAnimating = false;
    }, 300);
  }

  private resetDragState() {
    this.isDragging = false;
    this.touchStarted = false;
    this.moved = false;
    this.swipeDecided = false;
    this.isHorizontalSwipe = false;
    this.isVerticalSwipe = false;
    this.velocityX = 0;
    this.velocityY = 0;
  }
  
  getMinItemsForScreen(screenWidth: number): number {
    const breakpoints = Object.keys(this.customOptions.responsive).map(key => parseInt(key)).sort((a, b) => b - a); 
    for (const breakpoint of breakpoints) {
      if (screenWidth >= breakpoint) {
        return this.customOptions.responsive[breakpoint].items;
      }
    }
    const smallestBreakpoint = Math.min(...breakpoints);
    return this.customOptions.responsive[smallestBreakpoint].items;
  }

  onImageLoad() {
    this.imgLoading = false;
  }

  onImageError() {
    this.imgLoading = false;  
  }

  getUserWatchHistoryContents() {
    var userId = localStorage.getItem("userId");
    this.mycontentservice.getUserWatchHistory().subscribe(result => {
      if (result) {
        this.movies = result;
      } else {
        this.isLoading = false;
      }
    });
  }

  hoveredMovie: any = null;
  popupStyles = { top: '0px', left: '0px' };
  showPopup = false;
  popupTimeout: any;
  customOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    stagePadding: 0,
    pullDrag: true,
    dots: false,
    navSpeed: 300,
    nav: true,
    navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
    responsive: {
      0: {
        items: 3.1,
        nav: false,
        margin: 5
      },
      400: {
        items: 3.1,
        nav: false,
        margin: 5,
      },
      700: {
        items: 4,
        nav: false,
        margin: 8,
      },
      900: {
        items: 7.2,
        stagePadding: 0,
        margin: 8,
      },
      1200: {
        items: 7.2,
        stagePadding: 0,
        margin: 12,
      },
      1600: {
        items: 8,
        stagePadding: 0,
        margin: 12,
      },
    }
  };

  // contentTypeId arrives as 3 or "3" depending on the endpoint, so loose ==.
  isShort(movie: any): boolean {
    return movie?.contentTypeId == 3 || movie?.mediaLayout === 'short-vertical';
  }

  onMouseEnter(movie: any, event: MouseEvent) {
    if (this.isDragging) return;
    // Shorts don't get the hover preview popup on large screens — they're
    // single-click-to-play, and the popup's "Play / Watchlist / +Info" UI
    // doesn't fit the short-form interaction model.
    if (this.isShort(movie)) return;
    clearTimeout(this.popupTimeout);
    this.popupTimeout = setTimeout(() => {
      this.hoveredMovie = movie;
      this.imgLoading = true;
      const targetElement = (event.target as HTMLElement).closest('.movie-thumbnail-container') as HTMLElement;
      if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const popupWidth = window.innerWidth >= 1400 ? 420 : 380;
        let targetX = rect.left;
        let targetY = rect.top;
        const thumbnailCenter = rect.left + (rect.width / 2);
        const idealLeft = thumbnailCenter - (popupWidth / 2);
        if (idealLeft < 20) {
          targetX = 20;
        } else if (idealLeft + popupWidth > viewportWidth - 20) {
          targetX = viewportWidth - popupWidth - 20;
        } else {
          targetX = idealLeft;
        }
        targetY = targetY - 30;
        this.popupStyles.left = `${window.scrollX + targetX}px`;
        this.popupStyles.top = this.setToptoZero ? '30px' : `${window.scrollY + targetY}px`;
        this.showPopup = true;
      }
    }, 280);
  }

  onMouseLeave(event: MouseEvent) {
    clearTimeout(this.popupTimeout);
    this.popupTimeout = setTimeout(() => {
      if (!event.relatedTarget || !(event.relatedTarget as HTMLElement).closest('.popup-container')) {
        this.showPopup = false;
        this.hoveredMovie = null;
      }
    }, 180);
  }
  
  onPopupEnter() {
    clearTimeout(this.popupTimeout); 
  }
  
  onPopupLeave() {
    this.showPopup = false; 
    setTimeout(() => {
      this.hoveredMovie = null; 
    }, 250);
  }

  addVideoToWatchList(vid_lib_id: any) {
    const userId = localStorage.getItem('userId');
    this.mycontentservice.addInWatchList(userId, vid_lib_id).subscribe((result) => {
      if (result.message === 'success') {
        this.showNotication(result.message, 'Added to watchlist');
      }
      this.hoveredMovie.isInWatchList = true;
    })
  }

  removeVideoFromWatchList(vid_lib_id: any) {
    const userId = localStorage.getItem('userId');
    this.mycontentservice.removeFromWatchList(userId, vid_lib_id).subscribe((result) => {
      if (result.message === 'success') {
        this.showNotication(result.message, 'Removed from watchlist');
        const movieInArray = this.movies.find(movie => 
          movie.vidLibId === vid_lib_id || 
          movie.id === vid_lib_id
        );
        if (movieInArray) {
          movieInArray.isInWatchList = false;
          if (this.removeFromArrayOnUnwatchlist) {
            this.removeMovieFromArray(movieInArray);
          }
          this.movieRemovedFromWatchlist.emit(movieInArray);
          if (this.removeFromArrayOnUnwatchlist) {
            this.showPopup = false;
            this.hoveredMovie = null;
          }
        } else {
          if (this.hoveredMovie) {
            this.hoveredMovie.isInWatchList = false;
            if (this.removeFromArrayOnUnwatchlist) {
              this.removeMovieFromArray(this.hoveredMovie);
            }
            this.movieRemovedFromWatchlist.emit(this.hoveredMovie);
            if (this.removeFromArrayOnUnwatchlist) {
              this.showPopup = false;
              this.hoveredMovie = null;
            }
          }
        }
      }
    })
  }

  private removeMovieFromArray(movieToRemove: any) {
    const indexToRemove = this.movies.findIndex(movie => {
      if (movie === movieToRemove) {
        return true;
      }
      if (movie.vidLibId && movieToRemove.vidLibId && movie.vidLibId === movieToRemove.vidLibId) {
        return true;
      }
      if (movie.id && movieToRemove.id && movie.id === movieToRemove.id) {
        return true;
      }
      if (movie.title && movieToRemove.title && movie.title === movieToRemove.title) {
        return true;
      }
      return false;
    });
    if (indexToRemove !== -1) {
      const removedMovie = this.movies.splice(indexToRemove, 1)[0];
      this.updateCarouselView();
    } else {
      console.error('Movie not found in array for removal:', movieToRemove);
    }
  }

  removeMovieById(movieId: any) {
    const indexToRemove = this.movies.findIndex(movie => 
      movie.vidLibId === movieId || movie.id === movieId
    );
    if (indexToRemove !== -1) {
      this.movies.splice(indexToRemove, 1);
      this.updateCarouselView();
    }
  }

  showPlansModal(hoveredMovie: any) {
    const route = this.whitelabelService.getPrefixedRoute('channelplans');
    this.router.navigate([route], {
      queryParams: {
        channelId: hoveredMovie?.channelId,
        channelName: hoveredMovie?.channel_desc,
        vidLibId: hoveredMovie?.vidLibId
      }
    })
  }

  showNotication(type: any, message: any) {
    this.toastrService.showNotification(
      type,
      '',
      message,
      3000
    );
  }

  openPayments(hoveredMovie: any) {
    const route = this.whitelabelService.getPrefixedRoute('payment');
    this.router.navigate([route], {
      queryParams: {
        type: 'ppv',
        vidLibId: hoveredMovie?.vidLibId,
        movie: hoveredMovie?.title,
        durId: '2',
        planAmount: hoveredMovie.isChannelSubscribed ? hoveredMovie?.sub_value : hoveredMovie?.unSub_value,
        durationName: hoveredMovie?.ppv_valid_for + ' days',
        currency: hoveredMovie.currencyCode,
        currencySymbol: hoveredMovie.currencySymbol
      }
    });
  } 
  
  openDetailView(video: any) {
    if (this.bridgeService.isIOS() && this.router.url.includes('/watch')) {
      let url;
      if(video?.series_id){
        url = this.whitelabelService.getPrefixedRoute('shows', video.series_id);
      }else{
        url = this.whitelabelService.getPrefixedRoute('movies', video.title, video.vidLibId);
      }
      console.log("you are insdie the ios");
      const payload = {
        returnRoute : url
      };
      this.bridgeService.recoNavigation(payload);
      return;
    }
    if(video.categoryId){
      localStorage.setItem('category', video.categoryId);
    }
    // Shorts go straight to the player — no details page detour.
    // contentTypeId comes from the feed as number 3 or string "3", so loose ==.
    if (video?.mediaLayout === 'short-vertical' || video?.contentTypeId == 3) {
      this.openPlayerView(video);
      return;
    }
    if(video?.series_id){
      const route = this.whitelabelService.getPrefixedRoute('shows', video.series_id);
      this.router.navigate([route]);
    }else{
      const route = this.whitelabelService.getPrefixedRoute('movies', video.title, video.vidLibId);
      this.router.navigate([route]);
    }
  }  
  
  openPlayerView(video: any){
    if(video.categoryId){
      localStorage.setItem('category', video.categoryId);
    }
    // Short-drama entry (vertical aspect + series_id): use the shorts
    // swipe player but source the feed from the series episode list
    // instead of a category section.
    //
    // Two card shapes land here:
    //   - episode-level card  → has vidLibId. Seed with [video] so the
    //     first slide renders instantly; player tops up via
    //     loadInitialSeriesEpisodes.
    //   - series-level card   → no vidLibId (carries series_id +
    //     series_name only). Skip the seed and use series_id as the :id
    //     route segment purely for route-matching. The player's
    //     applyFeedState falls back to currentIndex=0 when startingShortId
    //     doesn't match any loaded episode, so the user lands on the
    //     first episode — the expected behavior for tapping a series.
    //
    // Checked before the contentTypeId==3 branch so series episodes always
    // get the series feed, regardless of whether they also carry
    // contentTypeId==3.
    if (video?.mediaLayout === 'short-vertical' && video?.series_id) {
      const startVidLibId = video.vidLibId ?? null;
      const idForRoute = startVidLibId ?? video.series_id;
      this.shortsFeed.seedSeries(video.series_id, startVidLibId ? [video] : [], startVidLibId);
      const route = this.whitelabelService.getPrefixedRoute('shorts', String(idForRoute));
      console.log(route)
      this.router.navigate([route], { queryParams: { seriesId: video.series_id } });
      return;
    }
    // Shorts route into the YT-style swipe player. Only dedicated shorts
    // rails (`section-shorts-scrollview`) opt into the paged swipe feed —
    // mixed sections that happen to include a stray short open single-mode
    // so the user doesn't end up swiping into movies.
    if (video?.contentTypeId == 3) {
      const isShortsFeed = this.sectionCategoryId && this.sectionTemplate === 'section-shorts-scrollview';
      if (isShortsFeed) {
        this.shortsFeed.seed(this.sectionCategoryId, this.movies, video?.vidLibId);
      } else {
        this.shortsFeed.seedSingle(video);
      }
      const route = this.whitelabelService.getPrefixedRoute('shorts', video.vidLibId);
      const queryParams = isShortsFeed
        ? { categoryId: this.sectionCategoryId }
        : {};
      this.router.navigate([route], { queryParams });
      return;
    }
    if(video?.series_id){
      const route = this.whitelabelService.getPrefixedRoute('shows', video.series_id, video.title, video.vidLibId, 'watch');
      this.router.navigate([route],{
        queryParams: { aspect: video?.mediaLayout }
      });
    }else{
      const route = this.whitelabelService.getPrefixedRoute('movies', video.title, video.vidLibId, 'watch');
      this.router.navigate([route]);
    }
  }
}